import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'

import { AUTH_CONFIG } from '../../Auth/auth0-variables';
import axios from 'axios';
import Plans from './Plans'
import CheckOut from './CheckOut'
import moment from 'moment'
const textField = 'name';
const valueField = 'id';
const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
})

export class Subscriptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            facilities: [],
            selected: undefined,
            loading: true,
            products: [],
            type:"annually",
            step: 'checkout',
            product: 'Scheduler',
            productId: 2
        };
        this.handleFacilityChange = this.handleFacilityChange.bind(this)
        this.changeStep = this.changeStep.bind(this);
        this.changeStepSub = this.changeStepSub.bind(this)
    }

    componentDidMount() {
        const items = [];
        
        this.props.facilities.forEach((element, index) => {
            const { facilityID, name } = element;
            const item = { [valueField]: facilityID, [textField]: name };
            items.push(item);
        });

        this.setState({
            facilities: items,
            selected: this.props.facilityId
        }, () => {
            this.checkSubs();
        });
    }         

    checkSubs() {
        
        let products = this.props.products.filter(x => x.FacilityId == this.state.selected);
        products.forEach((element, index) => {

            axios.get(AUTH_CONFIG.API_URL + "/api/Stripe/CheckSubscription?facilityId=" + this.props.facilityId + "&ProductID=" + element.ProductID)
                .then((response) => {
                    
                    if (response.data.status == "active") {
                        element.subStatus = 2;
                        element.amount = response.data.amount;
                        element.interval = response.data.interval;
                    } else {

                        let trialDate = new Date(element.TrialPeriodEnd);
                        let today = new Date();
                        if (trialDate < today) {
                            element.subStatus = 0;
                        } else {
                            element.subStatus = 1;
                        }
                    }
                    this.setState({
                        products: products
                    })
                });
        });
        this.setState({
            products:products
        })
    }

    changeStep(step, type, product, productId) {
        
        this.setState({
            step: step,
            type: type,
            product: product,
            productId: productId
        })
    }

    changeStepSub(step, type) {
        
        this.setState({
            step: step,
            type: type
        })
    }

    handleFacilityChange(event) {
        this.setState({
            selected: event.target.value
        }, () => {
            this.checkSubs();
        });
    }

    render() {
        return (
            <Fragment>
               
            {this.state.step == 'subs' && 
                    <div>
                    <div class="profile-overview">
                       
                   
                    <div className="facility-wrap">
                        {/*<DropDownListWithValueField*/}
                        {/*    data={this.state.facilities}*/}
                        {/*    valueField={valueField}*/}
                        {/*    textField={textField}*/}
                        {/*    value={this.state.selected}*/}
                        {/*    onChange={this.handleFacilityChange}*/}
                        {/*/>*/}
                    </div>
                    <table class="billing-subscriptions-table  billing-subscriptions__table table">
                        <colgroup>
                            <col class="billing-subscriptions-table__col-app-name" />
                            <col class="billing-subscriptions-table__col-plan-name" />
                            <col class="billing-subscriptions-table__col-price" />
                                <col class="billing-subscriptions-table__col-actions" style={{ width:'155px'}} />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Product name</th>
                                <th>Plan</th>
                                <th>Price/month</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.products &&
                                this.state.products.map((n) => {
                                    return (
                                        <tr class="billing-subscription-row">
                                            <td>{n.ProductName}</td>
                                            <td>
                                                {n.subStatus == 1 && 
                                                    <div class="billing-subscription-label billing-subscription-row__label">Trial ({moment(n.TrialPeriodEnd).diff(moment(), 'days')} d left)</div>
                                                }
                                                {n.subStatus == 0 &&
                                                    <div class="billing-subscription-label billing-subscription-row__label">Trial expired</div>
                                                }
                                                {n.subStatus == 2 &&
                                                    <div class="billing-subscription-label billing-subscription-row__label">Active</div>
                                                }
                                            </td>
                                            <td>
                                                {n.subStatus == 2 &&
                                                    <Fragment>{formatter.format(n.amount/100)}/{n.interval}</Fragment>
                                                }
                                            </td>
                                            <td>
                                                {n.subStatus == 2 &&
                                                    <button type="button" class="btn-textual btn btn-default" style={{width:'156px'}} onClick={() => this.changeStep('plans', null, n.ProductName, n.ProductID)} >Edit plan</button>
                                                }
                                                {(n.subStatus == 1 || n.subStatus == 0) &&
                                                    <button type="button" class="btn-textual btn btn-default" onClick={() => this.changeStep('plans', null, n.ProductName, n.ProductID)} >Purchase plan</button>
                                                }
                                            </td>
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </table>
                    <div class="clearfix">
                            <div class="billing-current-total billing-subscriptions__current-total pull-right" style={{
                                display: 'none'
                            }}>
                            <div>
                                Current total: <strong class="billing-current-total__value">0</strong>
                            </div>
                        </div>
                    </div>
                        <div class="billing-period-selector billing-subscriptions__period-selector" style={{
                            display:'none'}}>
                        <div>
                            <div class="form-group"><label class="control-label">Billing period</label></div>
                            <p class="billing-period-selector__current-period promoted">Monthly subscription</p>
                            <div role="toolbar" class="billing__actions btn-toolbar"><button disabled="" type="button" class="btn btn-lg btn-default">Change</button></div>
                        </div>
                    </div>
                    </div>
                </div>
                }
                {this.state.step == 'plans' &&
                    <Fragment>
                    <h1 style={{ fontSize: 24, fontWeight: 400 }}>Choose a pricing plan</h1>
                   
                    <div class="profile-overview">
                        <Plans changeStep={this.changeStepSub} />
                    </div>
                     </Fragment>
                }
                {this.state.step == 'checkout' &&
                    <Fragment>
                        <h1 className=" text-dark-to-light" style={{ fontSize: 24,fontWeight: 400}}>Choose your pricing plan</h1>
                    <div class="profile-overview">
                       
                        <CheckOut changeStep={this.changeStepSub} type={this.state.type} product={this.state.product} productId={this.state.productId}/>
                    </div>
                     </Fragment>
       }
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    facilities: state.appState.product.availableFacilities,
    facilityId: state.appState.product.facility.facilityID,
    products: state.user.products_facilities
});

export default connect(mapStateToProps)(Subscriptions);



